<template>
  <v-data-table
      v-model="selected"
      :show-select="totaleRegistrazioni > 0"
      item-key="_id"
      :headers="headers"
      :items="registrazioniSorted"
      :options.sync="options"
      :server-items-length="totaleRegistrazioni"
      :loading="loading"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      show-expand
      dense
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Prima nota non fiscale</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class="mb-2" @click="onNuovaRegistrazione">Nuova registrazione</v-btn>
<!--         <v-dialog v-model="dialogDelete" max-width="550px">
          <v-card>
            <v-card-title class="text-h5">Confermi cancellazione articoli selezionati ?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn>
              <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
      </v-toolbar>
      <!-- <filtri :usaTagliaColore="usaTagliaColore" @ricerca="onRicerca"/> -->
    </template>
<!--  OK per specificare il tipo di riga: fattura, incasso, costo, etc,   
      <template v-slot:[`item.speciali`]="{ item }">
      <v-icon v-if="item.lotti && item.lotti.gestione && item.lotti.gestione.abilita" small :title="titleLotti(item)" :color="coloreLotti(item)">mdi-clipboard-text-outline</v-icon>
      <v-icon v-if="item.lotti && !item.lotti.gestione && item.lotti.prodottoBase" small :title="titleLotti(item)" :color="coloreLotti(item)">mdi-clipboard-text-outline</v-icon>
      <v-icon v-if="item.bom && item.bom.gestione && item.bom.gestione.abilita" small :title="titleBom(item)" :color="coloreBom(item)">mdi-family-tree</v-icon>
      <v-icon v-if="item.eCommerce && item.eCommerce.abilita" small title="Abilitato per eCommerce" class="ml-2" @click="apriCommerce(item)">mdi-cart-outline</v-icon>
      <v-icon v-if="item.tipoBene === 'BUONOPASTO'" small title="Buono Pasto">mdi-cash-multiple</v-icon>
      <v-icon v-if="item.custom && item.custom.scalaTaglie && item.custom.scalaTaglie.prodottoMaster" small title="Master scala taglie">mdi-abacus</v-icon>
    </template> -->
    <template v-slot:[`item.data`]="{ item, index }">
      <component :is="'pData'" :item="itemData(item)" :index="index" :appoggio="null" @change="componentValueChange" :updateTrigger="updateTrigger"/>
    </template>
    <template v-slot:[`item.conto`]="{ item, index }">
      <component :is="'pMultiselect'" :item="itemConto(item)" :index="index" :disableClear="true" :appoggio="item.appoggio" @change="componentValueChange" :updateTrigger="updateTrigger" :suTable="true"/>
      <!-- <v-text-field v-else dense hide-details="auto" solo flat :value="itemUnitaMisura(item, true)" @click="re(index)"/> -->
    </template>
    <template v-slot:[`item.descrizione`]="{ item, index }">
      <component :is="'pTesto'" :item="itemDescrizione(item)" :index="index" @change="componentValueChange" :updateTrigger="updateTrigger" :suTable="true"/>
    </template>
    <template v-slot:[`item.entrate`]="{ item }">
      <v-text-field dense solo flat hide-details="auto" :value="item.entrate" prefix="€" background-color="transparent" reverse/>
    </template>
    <template v-slot:[`item.uscite`]="{ item }">
      <v-text-field dense solo flat hide-details="auto" :value="item.uscite" prefix="€" background-color="transparent" reverse/>
    </template>
<!--     <template v-slot:[`item.actions`]="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)" title="Modifica il prodotto">mdi-pencil</v-icon>
      <v-icon small class="mr-2" @click="duplicateItem(item)" title="Duplica il prodotto">mdi-content-duplicate</v-icon>
      <v-icon small class="mr-2" @click="deleteItemWithPassword(item)" title="Cancella il prodotto">mdi-delete</v-icon>
    </template> -->
    <template v-slot:no-data>
    </template>
    </v-data-table>
</template>

<script>
  import _ from 'lodash'
  import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  // import configurazioni from '@/services/configurazioniService.js'
  import pMultiselect from './elementi/multiselect'
  import pData from './elementi/data'
  import pTesto from './elementi/testo'
  import moment from 'moment'

  export default {
    components: {
      pMultiselect,
      pData,
      pTesto
    },
    mixins: [verificaLicenza],
    data () {
      return {
        totaleRegistrazioni: 0,
        registrazioni: [],
        selected: [],
        loading: false,
        options: { itemsPerPage: 50 },
        headers: [
          { text: 'Data', value: 'data', align: 'start', width: "10%" },
          { text: 'Conto', value: 'conto', width: "15%" },
          { text: 'Descrizione', value: 'descrizione' },
          { text: 'Cliente/Fornitore', value: 'anagrafica', width: "20%" },
          { text: 'Entrate', value: 'entrate', align: 'end', width: "10%" },
          { text: 'Uscite', value: 'uscite', align: 'end', width: "10%" },
          { text: 'Actions', value: 'actions', sortable: false },
          { text: '', value: 'data-table-expand' }
        ],
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        expanded: [],
        singleExpand: false,
        tab: {},        
        updateTrigger: 1,
        locRigaDocumento: null,
        rigaModello: {
          data: null,
          conto: null,
          descrizione: '',
          anagrafica: null,
          entrate: '',
          uscite: ''
        }
      }
    },
    computed: {
      registrazioniSorted() {
        const els = this.registrazioni
        if (this.options.sortBy && this.options.sortBy.length > 0) {
          return els
        } else {
          const elSorted = _.sortBy(els, ['descrizione', 'varianti.variante2.descrizione', 'varianti.variante1.descrizione'])
          return elSorted
        }
      }   
    },
    watch: {
      options: {
        async handler () {
          await this.getDataFromApi()
        },
        deep: true
      }
    },
    async mounted () {
      await this.gestioneToken()
    },
    methods: {
      onNuovaRegistrazione() {
        // let riga = JSON.parse(JSON.stringify(this.rigaModello))
        let riga = _.cloneDeep(this.rigaModello)
        riga.data = new Date()
        this.registrazioni.push(riga)
        this.trigger++        
      },
      async getDataFromApi () {
        try {
          this.loading = true
          const data = [] // await prodotti.getFilteredProducts(this.filtri, this.options)
          this.registrazioni = data && data.total_rows > 0 ? data.rows.map(x => x.doc) : []

          this.totaleRegistrazioni = data.total_rows
        } catch(err) {
          this.registrazioni = []
          this.totaleRegistrazioni = 0
        } finally {
          this.loading = false
        }
      },
      itemDescrizione(item, onlyValue) {
        if (onlyValue) {
          return _.get(item, 'descrizione', '') 
        }        
        return {
          "model": "descrizione",
          "valueField": "descrizione",
          "label": "Descrizione",
          "type": "TextArea",
          "required": true,
          value: this.updateTrigger && _.get(item, 'descrizione', '') 
        }
      },  
      itemConto(item, onlyValue) {
        if (onlyValue) {
          return _.get(item, 'conto', '') 
        }        
        return {
          "model": "conto",
          "subModel": "codice",
          "valueField": "conto",
          "type": "Multiselect",
          "label": "Conto",
          "source": "contabilita.conti",
          "required": true,
          "readOnly": true,
          "addForbidden": true,
          value: this.updateTrigger && _.get(item, 'conto', '') 
        }
      },
      itemData(item, onlyValue) {
        if (onlyValue) {
          return _.get(item, 'data', '') 
        }
        const value = _.get(item, 'data', '') 
        console.log('itemData', item)
        return  {
          "model": "data",
          "valueField": "data",
          "label": "Data",
          "type": "Data",
          "required": true,
          value: this.updateTrigger && _.get(item, 'data', '') 
        }
      },      
      async componentValueChange(data) {
        const { model, subModel, value, decimals, index } = data
        this.locRigaDocumento = this.registrazioni[index]
        let tgt = {}
        if (subModel) {
          let vv = value[subModel]
          if (decimals >= 0) {
            vv = +parseFloat(vv).toFixed(decimals)
          }
          // dot.str(model, vv, tgt)
          _.set(tgt, model, vv)
        } else {
          let vv = value
          if (decimals >= 0) {
            vv = +parseFloat(vv).toFixed(decimals)
          }
          // dot.str(model, vv, tgt)
          _.set(tgt, model, vv)
        }
        _.merge(this.registrazioni[index], tgt)
        // await this.aggiornaCorrelati(data)
      },
      async aggiornaCorrelati(data) {
        // this.locRigaDocumento.appoggio = this.locRigaDocumento.appoggio || {}
        // let tipoModifica = ''
        switch (data.model) {
          case 'data':
            this.locRigaDocumento.data = moment(data.value).toISOString()
            break
          default:
            break
        }
      }      
    }     
  }
</script>
